import dayjs from 'dayjs'
import 'dayjs/locale/de'
import { VALID_DATE_FORMATS } from '../../general/helper.js'
import { FieldValue, IFilterFieldsEntry } from './interface.js'

dayjs.locale('de')

export const validateFilterField = (filterField: IFilterFieldsEntry, fieldValue: FieldValue) => {
  switch (filterField.type) {
    case 'date':
      return isValidDate(fieldValue)
    case 'enum':
      return isValidEnum(filterField, fieldValue)
    default:
      return true
  }
}

export const isValidDate = (fieldValue: FieldValue) => {
  const isString = typeof fieldValue === 'string'

  if (isString) {
    for (const fmt of VALID_DATE_FORMATS) {
      const date = dayjs(fieldValue, fmt.format, true)

      if (date.isValid()) {
        return true
      }
    }
  }

  return false
}

export const isValidEnum = (filterField: IFilterFieldsEntry, fieldValue: FieldValue) => {
  const enumValues = filterField.enum

  if (!enumValues || typeof fieldValue !== 'string') {
    return false
  }

  const fieldValues = fieldValue!.split(';')
  for (const v of fieldValues) {
    if (!enumValues.includes(v)) {
      return false
    }
  }
  return true
}

export const getValidDateFormat = (fieldValue: FieldValue) => {
  const isString = typeof fieldValue === 'string'

  if(isString) {
    for (const fmt of VALID_DATE_FORMATS) {
      const date = dayjs(fieldValue, fmt.format, true)
  
      if (date.isValid()) {
        return fmt
      }
    }
  }

  return null
}
